import React,{useState, useEffect}  from 'react';
import Card from 'react-bootstrap/Card';
import Sides from '../Bars/Csharpsidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Csif(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  
return(
    <div>
      <Sides/>
      <Helmet>
 
 <title>C# If tutorial For Beginners</title>
 <meta name="description" content="C# if tutorial for beginners learn free if in C# is used for making a decision.If and else can be a block statement ,CodeExampler provides Free Online Tutorials for beginners" />
 <meta name="keywords" content="codeexampler,programming language,tutorial for begineers,C# if,c# if for,CSharp if,c# if for loop,c# exit for loop,exit while loop c#,c# continue,if foreach c#,c# foreach if,c# foreach continue" />
 <link rel="canonical" href="https://www.codeexampler.com/csharp-if" />
 </Helmet>

 <div className='lg:pl-56'>
    <h1 className="m-4 mh1">If statement in C#</h1>
    <div className="first">
        <a href="/csharp-control-structure">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/csharp-if-else">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
<p className="mt-4 para">If is used for making a decision.
If and else can be a block statement
</p>



<h2 className='headings'>If syntax in C#:</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
          {"\n"}{"\n"}
            <span className="qwerty-5">if</span>
            <span className="qwerty-3"> (</span>
            <span className="qwerty-10">condition</span>
            <span className="qwerty-3">)</span>
            {"\n"}
            <span className="qwerty-7">statement</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>



<h2 className='headings'>Q-Write a program to input a number and check this number is more than or equal to 100?</h2>
      <div style={{ background: 'black', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}  {"\n"}
            <span className="qwerty-5">namespace </span>
            <span className="qwerty-2">if</span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-7">class </span>
            <span className="qwerty-10">Program</span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-6">static </span>
            <span className="qwerty-5">void Main</span>
            <span className="qwerty-7"> (</span>
            <span className="qwerty-3">string </span>
            <span className="qwerty-10">[] </span>
            <span className="qwerty-7">args</span>
            <span className="qwerty-3">)</span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-7">  int </span>
            <span className="qwerty-3">a</span>
            <span className="qwerty-10">;</span>
            {"\n"}
            <span className="qwerty-4">  Console</span>
            <span className="qwerty-3">.WriteLine </span>
            <span className="qwerty-5">(</span>
            <span className="qwerty-6">"</span>
            <span className="qwerty-2">enter a number</span>
            <span className="qwerty-7">"</span>
            <span className="qwerty-3">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-7">  a </span>
            <span className="qwerty-2">= </span>
            <span className="qwerty-7">Convert </span>
            <span className="qwerty-5">.ToInt32 </span>
            <span className="qwerty-3">(</span>
            <span className="qwerty-4">Console.</span>
            <span className="qwerty-7">ReadLine </span>
            <span className="qwerty-1">()</span>
            <span className="qwerty-3">)</span>
            <span className="qwerty-10">;</span>
            {"\n"}
            <span className="qwerty-2"> if</span>
            <span className="qwerty-3"> (</span>
            <span className="qwerty-10">a</span>
            <span className="qwerty-3">&#62;</span>
            <span className="qwerty-10"> = </span>
            <span className="qwerty-1">100</span>
            <span className="qwerty-3">)</span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-4">  Console.</span>
            <span className="qwerty-3">WriteLine </span>
            <span className="qwerty-5">(</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-10">this no is </span>
            <span className="qwerty-3">greater </span>
            <span className="qwerty-2">than </span>
            <span className="qwerty-1">100</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-5">)</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}   {"\n"}
          </code>
        </pre>
      </div>

      <div>
        <h3 className="headings">Output</h3>
        <div style={{ background: 'black', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code>
              {"\n"}
              <span className="qwerty-10">enter a number</span>
              {"\n"}
              <span className="qwerty-1"> 101</span>
              {"\n"}  {"\n"}
              <span className="qwerty-7">Answer-</span>
              {"\n"}  {"\n"}
              <span className="qwerty-10">this no is</span>
              <span className="qwerty-6"> greater</span>
              <span className="qwerty-10"> than</span>
              <span className="qwerty-1"> 100</span>
              {"\n"}  {"\n"}
            </code>
          </pre>
        </div>
      </div>


<p className="mt-4 para">If you don't know about input in Csharp so check on <a href="https://www.codeexampler.com/csharp-input">C# input tutorial</a>.</p>

<h3 className="mt-4 mh3">IF Statement in C# with multiple conditions</h3>



<h2 className='headings'>Q-Write a program to input a number and print greater no in C#?</h2>
      <div style={{ background: 'black', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}  {"\n"}
            <span className="qwerty-5">namespace </span>
            <span className="qwerty-2">if</span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-7">class </span>
            <span className="qwerty-10">Program</span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-6">static </span>
            <span className="qwerty-5">void Main</span>
            <span className="qwerty-7"> (</span>
            <span className="qwerty-3">string </span>
            <span className="qwerty-10">[] </span>
            <span className="qwerty-7">args</span>
            <span className="qwerty-3">)</span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-7">  int </span>
            <span className="qwerty-3">a</span>
            <span className="qwerty-10">;</span>
            {"\n"}
            <span className="qwerty-4">  Console</span>
            <span className="qwerty-3">.WriteLine </span>
            <span className="qwerty-5">(</span>
            <span className="qwerty-6">"</span>
            <span className="qwerty-2">enter a value of a</span>
            <span className="qwerty-7">"</span>
            <span className="qwerty-3">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-7">  a </span>
            <span className="qwerty-2">= </span>
            <span className="qwerty-7">Convert </span>
            <span className="qwerty-5">.ToInt32 </span>
            <span className="qwerty-3">(</span>
            <span className="qwerty-4">Console.</span>
            <span className="qwerty-7">ReadLine </span>
            <span className="qwerty-6">()</span>
            <span className="qwerty-3">)</span>
            <span className="qwerty-10">;</span>
            {"\n"}
            <span className="qwerty-2">  If </span>
            <span className="qwerty-3">(</span>
            <span className="qwerty-10">a</span>
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-1">500</span>
            <span className="qwerty-3">)</span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-4">  Console</span>
            <span className="qwerty-3">.WriteLine</span>
            <span className="qwerty-5">(</span>
              <span className="qwerty-3">"</span>
            <span className="qwerty-10">a no</span>
            <span className="qwerty-3">" + </span>
            <span className="qwerty-10">a</span>
            <span className="qwerty-3"> + "</span>
            <span className="qwerty-2">is smaller than</span>
            <span className="qwerty-1"> 500</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-5">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}
            <span className="qwerty-2"> if</span>
            <span className="qwerty-3"> (</span>
            <span className="qwerty-10">a</span>
            <span className="qwerty-3">&#62;</span>
            <span className="qwerty-1">1000</span>
            <span className="qwerty-3">)</span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-4">  Console.</span>
            <span className="qwerty-3">WriteLine</span>
            <span className="qwerty-5">(</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-10">a no</span>
            <span className="qwerty-3">" + </span>
            <span className="qwerty-10">a </span>
            <span className="qwerty-3">+ "</span>
            <span className="qwerty-2">is greater than </span>
            <span className="qwerty-1">1000</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-5">)</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}   {"\n"}
          </code>
        </pre>
      </div>

      <div>
        <h3 className="headings">Output</h3>
        <div style={{ background: 'black', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code>
              {"\n"}
              <span className="qwerty-10">enter a value of a</span>
              {"\n"}
              <span className="qwerty-1"> 88</span>
              {"\n"}  {"\n"}
              <span className="qwerty-7">Answer-</span>
              {"\n"}  {"\n"}
              <span className="qwerty-10">a no</span>
              <span className="qwerty-1"> 88 </span>
              <span className="qwerty-10">is smaller than</span>
              <span className="qwerty-1"> 500</span>
              {"\n"}  {"\n"}
            </code>
          </pre>
        </div>
      </div>

  <h1 className="mt-5">  </h1>
       
  <div className="back">
        <a href="/csharp-control-structure">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/csharp-if-else">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
        </div>
    </div>
)

}
export default Csif;